module.exports = __webpack_public_path__ + "assets/d55804b76d84094a1945d03e473eb2a8.mp3";